import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/booking-meeting-room-request";

export type listType = {
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
  room_meeting_type?: string;
};

export type MeetingAgenda = {
  id_meeting_room: number;
  meeting_agenda_name: string;
  meeting_agenda_desc: string;
  participant_type: string;
  event_organizer: string;
  meeting_agenda_resolution: string;
  meeting_room_link: string;
  file_cover: MeetingRoomFile | null;
  file_information_calendar: MeetingRoomFile[];
};

export type MeetingRoomFile = {
  id_meeting_room_file: number | null;
  file_name: string;
  file_type: string;
  file_path: string;
  file_size: string;
};


export class BookingMeetingRoomRequestApi extends BaseAPI {

  static getMeetingRoomRequest(query?: listType): Promise<AxiosResponse> {
    return this.api.get(`${path}/list`, { params: { ...query } });
  }


  static getMeetingRoomDetailById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }


  static createInformationCalendar(body: MeetingAgenda): Promise<AxiosResponse> {
    return this.api.post(`${path}/information-calendar`, body)
  }
  static updateInformationCalendar(id_meeting_agenda: number, body: MeetingAgenda): Promise<AxiosResponse> {
    return this.api.patch(`${path}/information-calendar/${id_meeting_agenda}`, body)
  }
  static findOneInformationCalendar(id_meeting_room: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/${id_meeting_room}/information-calendar`)
  }
}
